@if (!isLoading){ @if(!isMobileDevice){
<div class="d-flex flex-column profile-container">
  <div class="d-flex justify-content-between align-items-center">
    <span class="profile-text">Profile Settings</span>
    <div class="btn-div">
    @if(showCancel){
    <button class="saveChanges-btn dp-secondary-btn " (click)="cancelEdit()">
      <span>Don't Save</span>
    </button>
  }@else{
    <button class="saveChanges-btn dp-primary-btn" (click)="editProfile()">
      <span>Edit Profile</span>
    </button>
  }
  @if(hasChanges()){
    <button class="saveChanges-btn dp-primary-btn" (click)="saveInput()">
      <span>Save Changes</span>
    </button>
  }
    </div>
  </div>
</div>

<div class="d-flex hello">
  <div class="profile-pic">
    @if(!isPicLoading){
    <!-- <input
      type="file"
      id="fileInput"
      (change)="onFileSelected($event)"
      hidden
    /> -->
    <img src="../../../assets/images/profilePic.png" alt="" height="144px" width="144px" />
    <div class="change-pic d-flex align-items-center justify-content-center" (click)="onClickUpload()">
      <img src="../../../assets/images/camera.svg" alt="" />
    </div>
    }
  </div>

  <div class="greet d-flex flex-column">
    <div class="greet-name">Jayguru, {{ profileData.first_name }} 🙏🏻</div>
    <div>
      <span class="greet-role">{{ profileData.role_name }}</span>
    </div>
    <!-- <div class="greet-since">Dp'ing since {{ profileYear }}</div> -->
  </div>
</div>

<form [formGroup]="profileForm" (ngSubmit)="saveInput()">
  <div class="details-cont">
    <div class="cont-head d-flex justify-content-between align-items-center">
      <span class="cont-head-text">Personal Details </span>
    </div>

    <div class="personal-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">First Name</label>
            <!-- <div class="input-container"> -->
              <!-- <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('firstName')" alt="" /> -->
            <input  type="text" class="dp-input-control searchInput bgReadonly" formControlName="firstName" />
            </div>
          <!-- </div> -->
        </div>
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">Last Name</label>
            <!-- <div class="input-container"> -->
              <!-- <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('lastName')" alt="" /> -->
            <input   type="text" class="dp-input-control searchInput bgReadonly" formControlName="lastName" />
            <!-- </div> -->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <div class="inpSec">
            <label class="inpLabel" for="">Phone Number</label>
            <!-- <div > -->
              <!-- <div class="input-img">
                @if (showEdit) {
                <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('number')" alt="" />
                } -->
              <input  type="text" [ngClass]="{'editable': showEdit}" class="d-flex searchInput bgReadonly dp-input-control" style="padding:10px 12px" formControlName="contactNumber" (keydown)="restrictOtpInput($event)" maxlength="10"/>
              <!-- <span
                ><img src="../../../assets/images/edit-box-line.svg" alt=""
              /></span> -->
            <!-- </div> -->
            <!-- </div>  -->
          </div>
        </div>
        @if(profileData.verified===1){
        <div class="col-12 col-md-4">
          <div class="inpSec">
            <label class="inpLabel" for="">DP Updated Phone Number</label>
            <div  class="d-flex dp-input-control searchInput bgReadonly">
              <input  type="text" class="number-inpt" formControlName="updatedContactNumber" />
            </div>
          </div>
        </div>
        }
        <div class="col-12 col-md-4">
          <div class="inpSec">
            <label class="inpLabel" for="">Email address</label>
            <!-- <div  class="d-flex dp-input-control searchInput bgReadonly"> -->
              <!-- <div class="input-img">
                @if (showEdit) {
                <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('email')" alt="" />
                } -->
              <!-- @if(!showEdit){ -->
              <input type="text" [ngClass]="{'editable': showEdit}" class="d-flex searchInput bgReadonly dp-input-control" formControlName="email" (keydown)="restrictEmailInput($event)"/>
              <!-- }@else{
              <input type="text" [ngClass]="{'editable': showEdit}" class="d-flex searchInput bgReadonly dp-input-control" formControlName="email" (keydown)="restrictEmailInput($event)" ngModel pattern="[a-zA-Z._%+-]+@[a-zA-Z.-]+\.[a-zA-Z]*"/>

              } -->
              <!-- <span
                ><img src="../../../assets/images/edit-box-line.svg" alt=""
              /></span> -->
              <!-- </div> -->
            <!-- </div> -->
            @if( profileForm.get('email')?.invalid &&
            profileForm.get('email')?.touched){
            <span class="error-text">Enter valid email</span>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">Family Code</label>
            <div  class="d-flex dp-input-control searchInput bgReadonly">
              <input   type="text" class="number-inpt" formControlName="fCode" />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">Philanthropy Name</label>
            <div  class="d-flex dp-input-control searchInput bgReadonly">
              <input type="text" class="number-inpt" formControlName="phlMemberName" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="details-cont">
    <div class="cont-head d-flex justify-content-between align-items-center">
      <span class="cont-head-text">Address Details</span>
    </div>
    <div class="personal-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">Address</label>
            <!-- <div  class="input-container">
              @if (showEdit) {
            <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('address')" alt="" />
              } -->
            <input [ngClass]="{'editable': showEdit}" type="text" class="dp-input-control searchInput bgReadonly" formControlName="address"  />
          <!-- </div> -->
        </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">PIN code</label>
            <!-- <div  class="input-container">
              @if (showEdit){
              <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('pincode')" alt="" />
              } -->
            <input [ngClass]="{'editable': showEdit}" type="text" class="dp-input-control searchInput bgReadonly" formControlName="pincode" (keydown)="restrictOtpInput($event)" maxlength="6"/>
          <!-- </div> -->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">District</label>
            @if(districtList.length <=1 ){
              <input  type="text" [readOnly]="isStateReadonly" class="dp-input-control searchInput bgReadonly"
                formControlName="district" />
             
            }@else{
               <select [ngClass]="{'editable': showEdit}" class="dp-input-control searchInput" formControlName="district">
                <!-- <option value="" disabled selected>SELECT DISTRICT</option> -->
                <option *ngFor="let item of districtList" [value]="item">{{ item }}</option>
              </select>
            }
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="inpSec">
            <label class="inpLabel" for="">State</label>
            @if(stateList.length <=1 ){
            <input type="text" [readOnly]="isStateReadonly" class="dp-input-control searchInput bgReadonly"
              formControlName="state" />
            }@else {
               <select [ngClass]="{'editable': showEdit}" class="dp-input-control searchInput" formControlName="state" (change)="getDistrict($event)">
                <!-- <option value="" disabled selected>SELECT STATE</option> -->
                <option *ngFor="let item of stateList" [value]="item">{{ item }}</option>
              </select>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="details-cont">

  <div class="permission-div d-flex justify-content-between align-items-center">
    <span class="permission-text">My Permissions</span>
  </div>
  @for(item of roleDetails;track item){
  <div class="role-div">
    <span class="role-name-text">Role: {{item.role}}</span>
    <div class="state-div d-flex flex-column">
      @for(details of item.stateNames;track details;let last=$last){
      <div class="d-flex justify-content-between" style="background-color: var(--bg-primary);">
        <span class="state-text">{{details.state}}</span>
        @if(!details.expand){
        <img src="../../../assets/images/down-arrow-dark.svg" style="cursor: pointer;"
          (click)="onExpandClick($index,item.role)">
        }@else{
        <img src="../../../assets/images/arrow-down-s-line.svg" style="cursor: pointer;"
          (click)="onCloseClick($index,item.role)">

        }
      </div>
      @if(details.expand){
      <div class="active-district-div d-flex">
        @if(details.active.length>0){
        <div class="d-flex flex-column">
          <span class="status-text">
            Active Districts
          </span>
          <span class="district-name-text">{{getAllDistricts(details.active)}}</span>
        </div>
        }
        <!-- @else if(details.inactive.length>0){
        <div class="d-flex flex-column">
          <span class="status-text">
            Inactive Districts
          </span>

          <span class="district-name-text">{{getAllDistricts(details.inactive)}}</span>
        </div>
        } -->
      </div>
      }
      @if(!last){
      <div style="border:1px solid var(--bg-overlay)"></div>
      }
      }
    </div>
  </div>

  }

</div>
} @else {

<div class="d-flex hello">
  <div class="profile-pic">
    @if(!isPicLoading){
    <input type="file" id="fileInput" (change)="onFileSelected($event)" hidden />
    <img src="../../../assets/images/profilePic.png" alt="" height="56px" width="56px" />
    }
  </div>

  <div class="greet d-flex flex-column">
    <div class="greet-name">{{ profileData.first_name }}</div>
    <div>
      <span class="greet-role">{{ profileData.role_name }}</span>
    </div>
  </div>
</div>

<form [formGroup]="profileForm">
  <div class="d-flex flex-column details-cont">
    <!-- <div class="row mb-4"> -->
    <div class="inpSec">
      <label class="inpLabel" for="">First Name</label>
      <!-- <div class="input-container"> -->
        <!-- <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('firstName')" alt="" /> -->
      <input type="text" class="dp-input-control searchInput bgReadonly " formControlName="firstName" />
      <!-- </div> -->
    </div>
    
    <div class="inpSec">
      <label class="inpLabel" for="">Last Name</label>
      <!-- <div class="input-container"> -->
        <!-- <img src="../../../assets/images/edit-box-line.svg" (click)="onEdit('lastName')" alt="" /> -->
      <input type="text" class="dp-input-control searchInput bgReadonly" formControlName="lastName" />
    <!-- </div> -->
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">Phone Number</label>
        <input [ngClass]="{'editable': showEdit}" type="text" class="d-flex searchInput bgReadonly dp-input-control" formControlName="contactNumber" (keydown)="restrictOtpInput($event)" maxlength="10"/>
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">Email address</label>
        <input  [ngClass]="{'editable': showEdit}" type="text" class="d-flex dp-input-control searchInput bgReadonly" formControlName="email" (keydown)="restrictEmailInput($event)"/>
        @if( profileForm.get('email')?.invalid &&
            profileForm.get('email')?.touched){
            <span class="error-text">Enter valid email</span>
            }
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">Family Code</label>
      <div class="d-flex dp-input-control searchInput  bgReadonly">
        <input type="text" class="number-inpt" formControlName="fCode" />
      </div>
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">Philanthropy Name</label>
      <div class="d-flex dp-input-control searchInput  bgReadonly">
        <input type="text" class="number-inpt" formControlName="phlMemberName" />
      </div>
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">Address</label>
      <input [ngClass]="{'editable': showEdit}" type="text" class="dp-input-control searchInput bgReadonly" formControlName="address" />
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">PIN code</label>
      <input [ngClass]="{'editable': showEdit}" type="text" class="dp-input-control searchInput bgReadonly" formControlName="pincode" (keydown)="restrictOtpInput($event)" maxlength="6"/>
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">District</label>
      @if(districtList.length <= 1){
        <input  type="text" [readOnly]="isStateReadonly" class="dp-input-control searchInput bgReadonly"
          formControlName="district" />
       
      }@else{
         <select [ngClass]="{'editable': showEdit}" class="dp-input-control searchInput bgReadonly" formControlName="district">
          <!-- <option value="" disabled selected>SELECT DISTRICT</option> -->
          <option *ngFor="let item of districtList" [value]="item">{{ item }}</option>
        </select>
      }
    </div>

    <div class="inpSec">
      <label class="inpLabel" for="">State</label>
      @if(stateList.length<=1){
      <input type="text" [readOnly]="isStateReadonly" class="dp-input-control searchInput bgReadonly"
        formControlName="state" />
      }@else{
         <select [ngClass]="{'editable': showEdit}" class="dp-input-control searchInput bgReadonly" formControlName="state" (change)="getDistrict($event)">
          <!-- <option value="" disabled selected>SELECT STATE</option> -->
          <option *ngFor="let item of stateList" [value]="item">{{ item }}</option>
        </select>
      }
    </div>
    <!-- </div> -->
  </div>
</form>


<div class="details-cont-mob d-flex flex-column">

  <div class="details-cont" style="padding: 0px; padding-bottom: 20px;">

    <div class="permission-div d-flex justify-content-between align-items-center">
      <span class="permission-text">My Permissions</span>
    </div>
    @for(item of roleDetails;track item){
    <div class="role-div">
      <span class="role-name-text">Role: {{item.role}}</span>
      <div class="state-div d-flex flex-column">
        @for(details of item.stateNames;track details;let last=$last){
        <div class="d-flex justify-content-between" style="background-color: var(--bg-primary);">
          <span class="state-text">{{details.state}}</span>
          @if(!details.expand){
          <img src="../../../assets/images/arrow-down-s-line.svg" style="cursor: pointer;"
            (click)="onExpandClick($index,item.role)">
          }@else{
          <img src="../../../assets/images/down-arrow-dark.svg" style="cursor: pointer;"
            (click)="onCloseClick($index,item.role)">

          }
        </div>
        @if(details.expand){
        <div class="active-district-div d-flex">
          @if(details.active.length>0){
          <div class="d-flex flex-column">
            <span class="status-text">
              Active Districts
            </span>
            <span class="district-name-text">{{getAllDistricts(details.active)}}</span>
          </div>
          }
          <!-- @else if(details.inactive.length>0){
          <div class="d-flex flex-column">
            <span class="status-text">
              Inactive Districts
            </span>

            <span class="district-name-text">{{getAllDistricts(details.inactive)}}</span>
          </div>
          } -->
        </div>
        }
        @if(!last){
        <div style="border:1px solid var(--bg-overlay)"></div>
        }
        }
      </div>
    </div>

    }

  </div>

</div>
<div class="btn-div">

@if(showCancel){
  <button class="dp-secondary-btn " style="width: 100%; position: sticky; padding: 10px;" (click)="cancelEdit()">
    <span>Don't Save</span>
  </button>
}@else{
  <button class="dp-primary-btn" style="width: 100%; position: sticky; padding: 10px;" (click)="editProfile()">
    <span>Edit Profile</span>
  </button>
}
@if(hasChanges()){
  <button class="dp-primary-btn" style="width: 100%; position: sticky;" (click)="saveInput()">
    <span>Save Changes</span>
  </button>
}
</div>
}

}